var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.status !== 'available' || !this.ctaPurchase)?_c('div',{staticClass:"consumer-gift-card-status h-text-1",style:(("color: " + _vm.labelColor + ";"))},[_c('span',[_vm._v(_vm._s(_vm.labelText))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }